// extracted by mini-css-extract-plugin
export default {"Mui-expanded":"security_Mui-expanded__VTdgW","manualCodeExpander":"security_manualCodeExpander__dIGCW","accordianText":"security_accordianText__dZS8F"};